import { IncomingMessage } from 'http';

import { QueryFunctionContext, QueryKey } from '@tanstack/react-query';

import { fetchStocks } from '../../../services/stocks';
import { getStockKey } from '../query-keys';

const getStock = (
  values: {
    locale: string;
    no_round?: boolean;
    stocks: Array<{
      part?: string;
      vehicle?: string;
      category?: string;
    }>;
  },
  req?: IncomingMessage
): [
  QueryKey,
  (values: QueryFunctionContext) => ReturnType<typeof fetchStocks>
] => [
  getStockKey(values),
  ({ queryKey: [, locale, options] }) => {
    return fetchStocks(
      {
        locale: locale,
        options,
      },
      req
    );
  },
];

export default getStock;
